import { FormGroup } from "@material-ui/core";
import Select from "react-select";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, CardBody } from "reactstrap";
import avatar from "./../../assets/images/users/avatar-6.jpg";
import { UsersService } from "./../../globals/services/users.service";
import { User } from "hc-entities";
import { useHistory, Link } from 'react-router-dom';

import makeAnimated from "react-select/animated";
import { showLoader } from "../../store/actions/mainActions";
import { resetModal, setModalChild, setModalState } from "../../store/actions/modalActions";
import { EditUserForm } from "./EditUserForm";
import moment from "moment";
import {setUsers} from "../../store/actions/usersActions";
const animatedComponents = makeAnimated();



export const CurrentUser = (props) => {
  const { currentUser, setCurrentUser } = props;
  const { communities, courses } = useSelector((state) => state.content);
  const [user, setUser] = useState({});
  const [tempPassword, setTempPassword] = useState(undefined);
  const usersService = UsersService();
  const history = useHistory();


  const dispatch = useDispatch();

  const openCurrentSeminar = (item) => {
    history.push({
      pathname: '/CurrentEventEditForm/' + item,
    });
  }

  const fetchUserData = async () => {
    try {
      setUser(null);
      const user = await usersService.getUserById(currentUser._id);
      if (user) {
        setUser(user.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const closeUserSection = () => {
    document.querySelector(".currentUserSection").classList.remove('currentUserSectionOpened');
    setUser(null);
  }

  const generatePassword = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    return result;
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchUserData();

    return () => {

      setTempPassword(undefined);
    }
  }, [currentUser, setUser]);

  const renderUserAvatar = (user) => {
    if (user) {
      return (
        <div className="px-3 py-4 d-flex justify-content-start align-items-center">
          <div className="d-flex align-items-center mx-2">
            <img className="rounded-circle avatar-sm" src={user?.image ? user.image : avatar} alt="" />
          </div>
          <div className="user-details d-flex flex-column align-items-start mb-0">
            <h4 className="mb-0">{user?.fullName}</h4>
            <h5 className="mb-0">{user?.email}</h5>
            {user?.alternateEmail?<h6 className="mb-0">{user.alternateEmail}</h6>:null}
            {user?.secondAlternateEmail?<h6 className="mb-0">{user.secondAlternateEmail}</h6>:null}
            {user?.secondaryEmail?<h6 className="mb-0">{user.secondaryEmail}</h6>:null}
          </div>
        </div>
      );
    }
    return null;
  };
  const renderCourses = () => {
    let userCourses = [];
    if (courses && Array.isArray(courses) && currentUser) {
      userCourses = courses?.filter(c => {
        if (c) {
          return c.communityIds?.find(cid => currentUser.communities?.find(urole => urole.communityId === cid))
        } return false
      })
    }
    return userCourses.map((c, i) => <div key={i} className="mb-1">
      <p>{c.eventName}</p>
    </div>)

  }

  const toggleBanned = async () => {
    try {
      const usersService = UsersService();
      if (user) {
        if (user.banned === true) {
          const _user = new User({
            ...user,
            banned: false,
            statusChanged: Date.now()
          });
          dispatch(showLoader(true))
          //const res = await usersService.update(_user);
          dispatch(showLoader(false))
          setCurrentUser(null)
        } else {
          const _user = new User({
            ...user,
            banned: true,
            statusChanged: Date.now()
          });
          dispatch(showLoader(true))
          //const res = await usersService.update(_user);
          dispatch(showLoader(false))
          setCurrentUser(null)
        }
      }
    } catch (err) {
      dispatch(showLoader(false))
      console.error(err);
    }
  }

  const resetPassword = async () => {
    try {
      const usersService = UsersService();
      const pass = generatePassword(8);
      if (user) {
        const _user = new User({
          ...user,
          password: pass
        });
        dispatch(showLoader(true))
        //const res = await usersService.update(_user);
        dispatch(showLoader(false))
        setTempPassword(pass)
      }
    } catch (err) {
      console.error(err);
    }
  }

  const renderActions = () => {
    return (
      <Fragment>
        <div className="col-12 d-flex justify-content-center flex-wrap">
          <div className="mx-1 my-1">
            <Button color="danger" onClick={toggleBanned}>{currentUser?.banned ? 'Unblock' : 'Block'}</Button>
          </div>
          <div className="mx-1 my-1">
            <Button color="primary" onClick={resetPassword}>Reset Password</Button>
          </div>
          <div className="mx-1 my-1">
            <Button color="success" onClick={openEditUserModal} >
              Edit
            </Button>
          </div>
        </div>
      </Fragment>
    );
  };

  const handleCommunityChange = async (selected) => {
    try {
      const usersService = UsersService();
      setUser({
        ...user,
        userCommunities: selected,
      });
      const _user = new User({
        ...user,
        userCommunities: selected.map((s) => ({ _id: s.value, name: s.label })),
        communities: selected.map((s) => ({ communityId: s.value, role: "participant" })),
      });
      //const res = await usersService.update(_user);
    } catch (err) {
      console.error(err);
    }
  };

  const renderUserCommunities = () => {
    return (
        <Fragment>
          <div className="d-flex flex-row mb-3 flex-wrap">
            {user.userCommunities?.map((c, i) => (
              <div key={i} className="mr-2 p-1 userEntityRelated">
                <p>{c.communityTitle ? c.communityTitle : c.communityName}</p>
              </div>
            ))}
          </div>
        </Fragment>
    );
  };

  const renderUserSeminars = () => {
    return (
        <Fragment>
          <div className="d-flex flex-row mb-3 flex-wrap">
            {user.userSeminars?.map((c, i) => (
                <div key={i} className="mr-2 p-1 userEntityRelated" onClick={()=>openCurrentSeminar(c._id)}>
                  <p>{c.eventTitle ? c.eventTitle : c.eventName}</p>
                </div>
            ))}
          </div>
        </Fragment>
    );
  };

  const renderUserClasses = () => {
    return (
        <Fragment>
          <div className="d-flex flex-row mb-3 flex-wrap">
            {user.userClasses?.map((c, i) => (
                <div key={i} className="mr-2 p-1 userEntityRelated">
                  <p>{c.sessionTitle ? c.sessionTitle : c.sessionName}</p>
                </div>
            ))}
          </div>
        </Fragment>
    );
  };

  const renderUserCurricula = () => {
    return (
        <Fragment>
          <div className="d-flex flex-row mb-3 flex-wrap">
            {user.userCurricula?.map((c, i) => (
                <div key={i} className="mr-2 p-1 userEntityRelated">
                  <p>{c.entityTitle}</p>
                </div>
            ))}
          </div>
        </Fragment>
    );
  };

  const saveUser = async (user) => {
    const usersService = UsersService()
    dispatch(showLoader(true))
    await usersService.edit({ ...user, _id: currentUser._id });
    dispatch(resetModal());
    dispatch(showLoader(false))
    setCurrentUser(null)
  }

  const openEditUserModal = () => {
    dispatch(setModalChild(<EditUserForm handleAction={saveUser} user={currentUser} />))
    dispatch(setModalState(true))
  }



  return user ? (
    <div className="CurrentUserContainer">
        <div className="closeUserSection" onClick={(e)=>closeUserSection()}>X</div>
        <div className="row">{renderUserAvatar(user)}</div>
        <div className="row">{renderActions()}</div>

        <div className="row my-4 justify-content-center">
          <div className="d-flex justify-content-center">
            <h5 className="">User's Communities ({user.userCommunities ? user.userCommunities.length : 0})</h5>
          </div>
          {renderUserCommunities()}
        </div>


        <div className="row my-4 justify-content-center">
          <div className="d-flex justify-content-center">
            <h5 className="">User's Seminars ({user.userSeminars ? user.userSeminars.length : 0})</h5>
          </div>
          {renderUserSeminars()}
        </div>

        <div className="row my-4 justify-content-center">
          <div className="d-flex justify-content-center">
            <h5 className="">User's Classes ({user.userClasses ? user.userClasses.length : 0})</h5>
          </div>
          {renderUserClasses()}
        </div>

      {user.userCurricula && user.userCurricula.length > 0 ?
          <div className="row my-4 justify-content-center">
            <div className="d-flex justify-content-center">
              <h5 className="">User's Curricula ({user.userCurricula ? user.userCurricula.length : 0})</h5>
            </div>
            {renderUserCurricula()}
          </div>
          : null
      }


        {
          tempPassword ? <div className="row my-4 justify-content-center">
            {`User's new password: ${tempPassword}`}
          </div> : null
        }

    </div>
  ) :
      <div>
        User information is loading, please wait...
      </div>;
};
